import { gql } from '@/__generated__/gql';

export const RENDERING_TEMPLATES_QUERY = gql(`
  query GenerateSignaturePacketPageRenderingTemplates($input: RenderingTemplateQueryInput) {
    renderingTemplates(input: $input) {
      id
      name
      template
      investmentId
      category
      entityType
      taxExempt
      initial
      eligibility
    }
  }
`);

export const GET_BANK_ACCOUNTS_AND_CONTACTS_QUERY = gql(`
  query GenerateSignaturePacketPageLegalEntityBankAccountsAndContacts($id: String!) {
    legalEntity(id: $id) {
      id
      contacts {
        id
        type
        name
        email
        data
        legalEntityId
        tenantId
        createdAt
        updatedAt
        isInvestor
      }
      bankAccounts {
        id
        name
        tenantId
        legalEntityId
        data {
          address {
            city
            country
            state
            streetAddress
            zipCode
          }
          accountName
          accountNumber
          furtherCredit
          transferType
          transferCode
        }
        createdAt
        updatedAt
      }
    }
  }
`);

export const ENTITY_CATEGORIES_QUERY = gql(`
  query GenerateSignaturePacketPageEntityCategories {
    renderingTemplateCategories {
      category
      entityTypes
    }
  }
`);

export const GENERATE_SUBSCRIPTION_DOCUMENT_MUTATION = gql(`
  mutation GenerateSignaturePacketPageGenerateSubscriptionDocument($input: GenerateSubscriptionDocumentInput!) {
    generateSubscriptionDocument(input: $input) {
      id
      docusignEnvelopeId
      currentStatus {
        name
      }
    }
  }
`);
